import React from 'react';
import { Link } from 'react-router-dom';
import { Bot, Mail, Linkedin, Send } from 'lucide-react';

// Custom SVG Icons
const InstagramIcon = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_929_221)">
      <path d="M32.0002 34.8376C74.8162 -9.55696 122.389 0.106422 339.413 -0.000244141C400.596 0.106421 402.986 0.618496 414.911 2.34644C466.943 9.83444 506.431 46.8055 511.466 110.955C512.149 119.532 512.149 392.397 511.488 400.81C506.752 461.034 472.107 495.574 429.526 506.56C397.632 514.816 114.667 514.816 82.7307 506.602C-19.5413 480.17 0.000244141 367.893 0.000244141 255.893C0.000239908 121.024 -8.23441 76.6296 32.0002 34.8376ZM413.184 98.6882C376.923 62.4277 327.889 66.9631 255.908 66.9646C178.465 66.9617 104.933 60.09 76.843 132.181C65.2377 161.963 66.9221 200.64 66.9221 256.021C66.9221 304.618 65.3658 350.293 76.843 379.84C104.875 451.989 179.029 445.078 255.914 445.078C330.09 445.078 406.571 452.8 435.008 379.84C446.635 349.76 444.928 311.658 444.928 256.021C444.928 182.165 449.002 134.486 413.184 98.6882ZM239.019 101.035C400.597 100.779 421.163 82.8164 409.814 332.352C405.782 420.608 338.581 410.923 255.979 410.923C105.365 410.923 101.034 406.613 101.034 255.936C101.034 103.51 112.981 101.12 239.019 100.992V101.035ZM255.957 158.933C202.347 158.933 158.891 202.411 158.891 256.021C158.891 309.632 202.347 353.088 255.957 353.088C309.568 353.088 353.002 309.632 353.002 256.021C353.002 202.411 309.568 158.933 255.957 158.933ZM255.957 193.003C339.264 193.003 339.371 319.04 255.957 319.04C172.672 319.04 172.544 193.003 255.957 193.003ZM356.864 132.416C344.341 132.416 334.187 142.571 334.187 155.094C334.187 167.616 344.341 177.77 356.864 177.77C369.386 177.77 379.541 167.616 379.541 155.094C379.541 142.571 369.386 132.416 356.864 132.416Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_929_221">
        <rect width="512" height="512" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_929_196)">
      <path d="M448 0C483.296 0 512 28.704 512 64V448C512 483.296 483.296 512 448 512H352V336H400L432 256H352V192C352 174.336 366.336 176 384 176H416V96H352C298.976 96 256 138.976 256 192V256H192V336H256V512H64C28.704 512 0 483.296 0 448V64C0 28.704 28.704 0 64 0H448Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_929_196">
        <rect width="512" height="512" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const TwitterIcon = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_929_224)">
      <path d="M471.579 0C493.903 8.24648e-05 512 18.0971 512 40.4209V471.579C512 493.903 493.903 512 471.579 512H40.4209C18.0971 512 8.24755e-05 493.903 0 471.579V40.4209C8.24648e-05 18.0971 18.0971 8.24755e-05 40.4209 0H471.579ZM334.773 122.661C321.445 119.661 307.522 120.743 294.816 125.767C282.111 130.79 271.211 139.523 263.533 150.828C255.855 162.134 251.755 175.49 251.767 189.159C251.719 194.376 252.251 199.583 253.353 204.683C226.267 203.352 199.766 196.319 175.582 184.043C151.398 171.767 130.074 154.525 113.004 133.443C104.229 148.441 101.511 166.224 105.404 183.16C109.298 200.096 119.508 214.905 133.949 224.56C123.17 224.269 112.62 221.386 103.188 216.156V216.899C103.219 232.619 108.657 247.85 118.59 260.03C128.522 272.211 142.343 280.599 157.729 283.785C151.906 285.316 145.906 286.065 139.886 286.013C135.551 286.093 131.22 285.708 126.968 284.865C131.376 298.385 139.862 310.206 151.26 318.702C162.657 327.199 176.406 331.954 190.615 332.312C166.536 351.143 136.852 361.372 106.291 361.369C100.846 361.415 95.4034 361.099 90 360.424C121.162 380.525 157.485 391.146 194.562 390.998C319.867 390.998 388.372 287.16 388.372 197.157C388.372 194.154 388.372 191.252 388.136 188.35C401.477 178.716 412.952 166.731 422 152.982C409.51 158.44 396.298 162.066 382.772 163.748C397.03 155.289 407.689 141.888 412.725 126.087C399.38 134.012 384.778 139.593 369.551 142.589C360.22 132.605 348.102 125.661 334.773 122.661Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_929_224">
        <rect width="512" height="512" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_929_214)">
      <path d="M442.182 0C480.741 0 512 31.2588 512 69.8184V442.182C512 480.741 480.741 512 442.182 512H69.8184C31.2588 512 0 480.741 0 442.182V69.8184C0 31.2588 31.2588 0 69.8184 0H442.182ZM269.141 96.6113C231.414 93.4932 193.815 103.96 163.125 126.122C132.435 148.285 110.675 180.684 101.77 217.478C92.8646 254.271 97.4007 293.035 114.56 326.778L97.7168 408.553C97.542 409.367 97.537 410.208 97.7021 411.023C97.8673 411.839 98.1992 412.613 98.6768 413.295C99.3764 414.329 100.375 415.126 101.539 415.578C102.703 416.03 103.978 416.116 105.192 415.825L185.338 396.829C218.986 413.554 257.477 417.798 293.961 408.807C330.445 399.816 362.556 378.173 384.58 347.729C406.604 317.284 417.114 280.013 414.237 242.548C411.361 205.083 395.286 169.853 368.873 143.127C342.238 116.227 306.867 99.7295 269.141 96.6113ZM256 130.441C288.961 130.441 320.573 143.533 343.884 166.836C344.082 167.064 344.296 167.278 344.523 167.477C367.545 190.84 380.397 222.357 380.277 255.157C380.157 287.957 367.076 319.38 343.884 342.574C325.455 360.951 301.725 373.082 276.037 377.257C250.349 381.432 223.998 377.442 200.698 365.848L189.527 360.32L140.393 371.956L140.538 371.346L150.72 321.891L145.251 311.098C133.346 287.717 129.146 261.168 133.253 235.254C137.36 209.34 149.564 185.39 168.116 166.836C191.427 143.533 223.039 130.441 256 130.441ZM206.312 178.498C204.573 178.099 202.765 178.113 201.032 178.538C199.3 178.963 197.691 179.787 196.334 180.945C187.752 188.16 177.57 199.215 176.349 211.433C174.138 232.96 183.272 260.102 218.443 292.713L218.938 293.149C258.938 330.444 291.084 335.33 312.029 330.269C323.985 327.388 333.498 315.781 339.52 306.298C340.445 304.784 341.012 303.079 341.177 301.312C341.342 299.546 341.1 297.765 340.472 296.106C339.843 294.447 338.843 292.954 337.549 291.74C336.255 290.527 334.7 289.626 333.004 289.105L302.255 280.378C300.276 279.817 298.182 279.79 296.189 280.301C294.196 280.812 292.374 281.843 290.909 283.287L283.316 290.938C281.773 292.534 279.787 293.63 277.614 294.086C275.442 294.542 273.182 294.338 271.127 293.498C263.447 290.414 251.316 281.367 240.378 271.477C230.632 262.72 221.847 253.265 218.182 246.836C217.078 244.879 216.585 242.636 216.767 240.396C216.948 238.157 217.796 236.022 219.2 234.269L225.745 225.774C227.017 224.147 227.821 222.204 228.072 220.154C228.323 218.104 228.012 216.024 227.171 214.138L214.226 185.047C213.509 183.414 212.419 181.971 211.045 180.834C209.671 179.697 208.05 178.897 206.312 178.498Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_929_214">
        <rect width="512" height="512" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const Footer = ({ config }) => {
  const company = config?.company || {};
  const social = config?.social || {};

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Bot className="h-8 w-8 text-primary-400" />
              <span className="text-2xl font-bold">{company.name || "KL Accelerators"}</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              {company.tagline || "Accelerating Innovation with Ready-to-Deploy Solutions"}
            </p>
            <p className="text-gray-400 text-sm">
              Discover ready-to-deploy accelerators engineered for rapid adoption and real-world performance. 
              Built by experts, ready from Day One.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/browse" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Browse Accelerators
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/browse" className="text-gray-400 hover:text-primary-400 transition-colors">
                  By Tech Stack
                </Link>
              </li>
              <li>
                <Link to="/custom" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Custom Accelerators
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <p className="text-gray-400 flex items-center">
                <Mail className="h-4 w-4 text-primary-400 mr-2" />
                {company.contact_email || "contact@kadellabs.com"}
              </p>
            </div>

            {/* Social Media Links */}
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-3">Follow Us</h4>
              <div className="flex space-x-4">
                {social.facebook && (
                  <a href={social.facebook} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <FacebookIcon className="h-5 w-5" />
                  </a>
                )}
                {social.instagram && (
                  <a href={social.instagram} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <InstagramIcon className="h-5 w-5" />
                  </a>
                )}
                {social.twitter && (
                  <a href={social.twitter} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <TwitterIcon className="h-5 w-5" />
                  </a>
                )}
                {social.linkedin && (
                  <a href={social.linkedin} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <Linkedin className="h-5 w-5" />
                  </a>
                )}
                {social.telegram && (
                  <a href={social.telegram} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <Send className="h-5 w-5" />
                  </a>
                )}
                {social.whatsapp && (
                  <a href={social.whatsapp} target="_blank" rel="noopener noreferrer" 
                     className="text-gray-400 hover:text-primary-400 transition-colors">
                    <WhatsAppIcon className="h-5 w-5" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 {company.name || "KL Accelerators"}. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/cookie-policy" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;